import { render, staticRenderFns } from "./ModalItemNotes.vue?vue&type=template&id=3270816a"
import script from "./ModalItemNotes.vue?vue&type=script&lang=js"
export * from "./ModalItemNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports